import { render, staticRenderFns } from "./QueenPurchasesTable.vue?vue&type=template&id=44ae815e"
import script from "./QueenPurchasesTable.vue?vue&type=script&lang=js"
export * from "./QueenPurchasesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports